/*
 * @Description:
 * @Author: tongjunyi<tongjunyi@didiglobal.com>
 * @Date: 2023-06-27 17:22:10
 * @LastEditors: tongjunyi
 * @LastEditTime: 2023-11-08 15:37:18
 */
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';

import { sentryInit } from '@/lib';

import App from './App';
import './assets/styles/normalize.less';
import './lib/omega';

sentryInit();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  // <React.StrictMode>
  <HashRouter>
    <App />
  </HashRouter>
  // </React.StrictMode>
);
